export default "__VITE_ASSET__D6IV07Zb__"